import React, { useState } from "react";
import { BASE_URL } from "../../../api/rootApi";

const MakeAdmin = () => {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);

  const handleOnBlur = (e) => {
    setEmail(e.target.value);
  };

  const handleAdminSubmit = (e) => {
    const user = { email };
    fetch(`${BASE_URL}/users/admin`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(user),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.modifiedCount) {
          setEmail("");
          setSuccess(true);
        }
      });

    e.preventDefault();
  };

  return (
    <div className="flex flex-col items-center py-8">
      <h2 className="text-2xl font-bold mb-4">Make an Admin</h2>
      <form
        onSubmit={handleAdminSubmit}
        className="flex flex-col items-center space-y-4 w-full max-w-md"
      >
        <input
          type="email"
          placeholder="Enter Email"
          onBlur={handleOnBlur}
          value={email}
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900"
        />
        <button
          type="submit"
          className="w-full py-2.5 bg-slate-900 text-white font-medium rounded-lg hover:bg-amber-500 hover:text-slate-900 transition-all duration-300"
        >
          Make Admin
        </button>
      </form>
      {success && (
        <div className="mt-4 w-full max-w-md bg-green-100 text-green-700 border border-green-300 rounded-md p-4">
          Made Admin successfully!
        </div>
      )}
    </div>
  );
};

export default MakeAdmin;
